import React, { Component } from 'react';

class HowItWorks extends Component {
	render() {
		return (
			<>
				<h2>How to compute it yourself</h2>
				<ol>
					<li>
						First you need your path as a serie of x-y coordinates.
						Let's say we have 1000 points.
					</li>
					<li>
						Calculate the middle point of all these coordinates.
					</li>
					<li>
						We name this middle point our "endpoint".
						This endpoint is a your first vector (having a direction and length).
						It rotates nothing and is quite boring.
					</li>
					<li>
						Now repeat the calculation of the middle point from the point of view of our endpoint.
						But this time we <b>rotate each x/y coordinate</b> of our path with 1/1000 for each step
						so we are back to beginning after 1000 steps.
					</li>
					<li>
						This new middle point actually correspond to the vector that is rotating at the speed "1".
					</li>
					<li>
						Now you might get it?  <b>Repeat step 4 and 5</b> for vectors rotating at speed 2, 3, 4, 5, etc,
						and alternate with vectors rotating opposite direction.
					</li>
					<li>
						You're done with the computation and only need to do the plotting of a lot of vectors rotating at different speed.
					</li>
				</ol>
			</>
		);
	}
}

export default HowItWorks;